
<template>
  <div class="admin-home">
    
    <!-- Stats Grid -->
    <div class="stats-grid">
      <!-- Card 1: 会员单位 -->
      <div class="stat-card theme-blue">
        <span class="stat-label">会员单位</span>
        <span class="stat-value">{{ stats['会员单位'] }}</span>
        <div class="stat-icon icon-blue">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
            <path fill-rule="evenodd" d="M3 2.25a.75.75 0 00-.75.75v.54l1.838-.46a9.75 9.75 0 016.725.738l.108.054a8.25 8.25 0 005.58.652l3.109-.732a.75.75 0 00.548-.909l-.409-1.538a.75.75 0 00-.91-.549l-3.108.732a9.75 9.75 0 01-6.594-.77l-.108-.054a8.25 8.25 0 00-5.69-.625L3.75 2.25A.75.75 0 003 3v.54l.004-.004z" clip-rule="evenodd" />
            <path d="M7.5 15a3 3 0 100-6 3 3 0 000 6z" />
            <path fill-rule="evenodd" d="M1.5 21a3 3 0 013-3h15a3 3 0 013 3v.75a.75.75 0 01-.75.75H2.25a.75.75 0 01-.75-.75V21z" clip-rule="evenodd" />
          </svg>
        </div>
      </div>

      <!-- Card 2: 产业工人 -->
      <div class="stat-card theme-green">
        <span class="stat-label">注册用户</span>
        <span class="stat-value">{{ stats['产业工人'] }}</span>
        <div class="stat-icon icon-green">
           <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
             <path fill-rule="evenodd" d="M8.25 6.75a3.75 3.75 0 117.5 0 3.75 3.75 0 01-7.5 0zM15.75 9.75a3 3 0 116 0 3 3 0 01-6 0zM2.25 9.75a3 3 0 116 0 3 3 0 01-6 0zM6.31 15.117A6.745 6.745 0 0112 12a6.745 6.745 0 016.709 7.498.75.75 0 01-.372.568A12.696 12.696 0 0112 21.75c-2.305 0-4.47-.612-6.337-1.684a.75.75 0 01-.372-.568 6.787 6.787 0 011.019-4.38z" clip-rule="evenodd" />
             <path d="M5.082 14.254a8.287 8.287 0 00-1.308 5.135 9.687 9.687 0 01-1.764-.44l-.115-.04a.563.563 0 01-.373-.487l-.01-.121a3.75 3.75 0 013.57-4.047zM20.226 19.389a8.287 8.287 0 00-1.308-5.135 3.75 3.75 0 013.57 4.047l-.01.121a.563.563 0 01-.373.486l-.115.04c-.567.2-1.156.349-1.764.441z" />
           </svg>
        </div>
      </div>

      <!-- Card 3: 本月新增 -->
      <div class="stat-card theme-orange">
        <span class="stat-label">本月新增</span>
        <span class="stat-value">{{ stats['本月新增'] }}</span>
        <div class="stat-icon icon-orange">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
            <path fill-rule="evenodd" d="M15.22 6.268a.75.75 0 01.968-.432l5.942 2.28a.75.75 0 01.431.97l-2.28 5.941a.75.75 0 11-1.4-.537l1.63-4.251-1.086.483a11.2 11.2 0 00-5.45 5.174.75.75 0 01-1.199.19L9 12.31l-6.163 6.162a.75.75 0 11-1.06-1.061l6.693-6.693a.75.75 0 011.06 0l3.669 3.669a9.7 9.7 0 013.995-4.8l1.085-.484-4.25-1.631a.75.75 0 01-.432-.97z" clip-rule="evenodd" />
          </svg>
        </div>
      </div>

      <!-- Card 4: 招聘信息 -->
      <div class="stat-card theme-cyan">
        <span class="stat-label">招聘</span>
        <span class="stat-value">{{ stats['招聘总量'] }}</span>
        <div class="stat-icon icon-cyan">
          <!-- Briefcase Icon -->
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
            <path fill-rule="evenodd" d="M7.5 5.25a3 3 0 013-3h3a3 3 0 013 3v.205c.933.085 1.857.197 2.774.334 1.454.218 2.476 1.483 2.476 2.917v3.033c0 1.211-.734 2.352-1.936 2.752A24.726 24.726 0 0112 15.75c-2.73 0-5.357-.442-7.814-1.259-1.202-.4-1.936-1.541-1.936-2.752V8.706c0-1.434 1.022-2.7 2.476-2.917A48.814 48.814 0 017.5 5.455V5.25zm7.5 0v.09a49.488 49.488 0 00-6 0v-.09a1.5 1.5 0 011.5-1.5h3a1.5 1.5 0 011.5 1.5zm-3 8.25a.75.75 0 100-1.5.75.75 0 000 1.5z" clip-rule="evenodd" />
            <path d="M3 18.4v-2.796a4.3 4.3 0 00.713.31A26.226 26.226 0 0012 17.25c2.892 0 5.68-.468 8.287-1.335.252-.084.49-.189.713-.311V18.4c0 1.452-1.047 2.728-2.523 2.923-2.12.282-4.282.427-6.477.427a49.19 49.19 0 01-6.477-.427C4.047 21.128 3 19.852 3 18.4z" />
          </svg>
        </div>
      </div>
    </div>

    <!-- Chart Section -->
    <div class="chart-section">
      <div class="section-header">
        <h2>用户增长趋势</h2>
        <div class="legend-indicator">
          <span class="dot"></span>
          <span>近30天变化</span>
        </div>
      </div>
      <div class="chart-container">
        <LineChart :chartData="chartData" :options="chartOptions"></LineChart>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, onMounted, computed } from 'vue';
import LineChart from '../../components/LineChart.vue';
import workerService from "@/api/workerService";
import jobService from "@/api/jobService";

export default {
  name: 'AdminHome',
  components: {
    LineChart,
  },
  setup() {
    const stats = ref({
      '会员单位': 0,
      '产业工人': 0,
      '本月新增': 0,
      '招聘总量': 0,
    });
    
    // Add Date formatted
    const currentDate = computed(() => {
      const date = new Date();
      return date.toLocaleDateString('zh-CN', { year: 'numeric', month: 'long', day: 'numeric', weekday: 'long' });
    });

    const chartData = ref({
      labels: [],
      datasets: [
        {
          label: '用户增长',
          backgroundColor: 'transparent',
          borderColor: '#135bec',
          borderWidth: 3,
          pointBackgroundColor: '#ffffff',
          pointBorderColor: '#135bec',
          pointBorderWidth: 2,
          pointRadius: 0,
          pointHoverRadius: 6,
          fill: false,
          tension: 0.45,
          data: [],
        },
      ],
    });
    
    const chartOptions = ref({
      responsive: true,
      maintainAspectRatio: false,
      plugins: {
        legend: { display: false },
        tooltip: {
          backgroundColor: 'rgba(15, 23, 42, 0.9)',
          padding: 12,
          titleFont: { size: 13 },
          bodyFont: { size: 13 },
          cornerRadius: 6,
          displayColors: false,
          intersect: false,
          mode: 'index',
        }
      },
      scales: {
        x: {
          grid: { display: false },
          ticks: {
            color: '#94a3b8',
            font: { size: 11 },
            maxRotation: 0,
            autoSkip: true,
            maxTicksLimit: 7 // Limit x-axis labels
          }
        },
        y: {
          grid: {
            borderDash: [4, 4],
            color: '#f1f5f9',
            drawBorder: false,
          },
          ticks: {
            color: '#94a3b8',
            padding: 10,
            font: { size: 11 },
            maxTicksLimit: 5 // Limit y-axis ticks
          },
          beginAtZero: true,
        },
      },
      interaction: {
        mode: 'nearest',
        axis: 'x',
        intersect: false
      }
    });

    const fetchStats = async () => {
      try {
        const response = await workerService.getHomeStats();
        const data = response.data;
        stats.value['会员单位'] = data['会员单位'];
        stats.value['产业工人'] = data['工人总数'];
        stats.value['本月新增'] = data['本月新增'];
        
        // 获取招聘统计
        const jobStats = await jobService.getJobStats();
        const total = jobStats.data.total || 0;
        const active = jobStats.data.active || 0;
        stats.value['招聘总量'] = `${active} / ${total}`;
      } catch (error) {
        console.error('Error fetching home stats:', error);
      }
    };

    const fetchDailyNewWorkers = async () => {
      try {
        const response = await workerService.getDailyNewWorkers();
        const labels = Object.keys(response.data);
        const data = Object.values(response.data);

        // Update chart data
        chartData.value = {
          labels,
          datasets: [
            {
              label: '新增用户',
              // No background color needed for line chart
              backgroundColor: 'transparent',
              borderColor: '#135bec',
              borderWidth: 3, // Slightly thicker for line-only
              pointBackgroundColor: '#ffffff',
              pointBorderColor: '#135bec',
              pointBorderWidth: 2,
              pointRadius: 0, // Keep clean
              pointHoverRadius: 6,
              fill: false, // Disable area fill
              tension: 0.45, // Smoother curve
              data,
            },
          ],
        };
      } catch (error) {
        console.error('Error fetching daily new workers:', error);
      }
    };

    onMounted(async () => {
      await fetchStats();
      await fetchDailyNewWorkers();
    });

    return {
      stats,
      chartData,
      chartOptions,
      currentDate
    };
  },
};
</script>

<style scoped>
/* Scoped CSS based on design system */
.admin-home {
  padding: 16px; /* Reduced padding */
  width: 100%;
  font-family: 'Public Sans', 'Noto Sans SC', sans-serif;
  color: #1e293b;
  height: calc(100vh - 50px);
  display: flex;
  flex-direction: column;
}

/* Stats Grid */
.stats-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  gap: 1.5rem;
  margin-bottom: 1.5rem;
  flex-shrink: 0;
}

/* Unified Clean Card Theme */
.stat-card {
  background: white;
  border-radius: 12px;
  padding: 20px 24px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-shadow: 0 1px 3px rgba(0,0,0,0.1), 0 1px 2px rgba(0,0,0,0.06);
  transition: all 0.2s;
  border: 1px solid #e2e8f0;
  position: relative;
  overflow: hidden;
}

.stat-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 3px;
  background: currentColor;
  opacity: 0;
  transition: opacity 0.2s;
}

.stat-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
}

.stat-card:hover::before {
  opacity: 1;
}

.stat-label {
  font-size: 1rem;
  font-weight: 500;
  color: #64748b;
  flex: 0 0 auto;
}

.stat-value {
  flex: 1;
  text-align: center;
  font-size: 2.5rem;
  font-weight: 700;
  color: #0f172a;
  line-height: 1;
  margin: 0 16px;
}

/* Theme Colors for Values */
.theme-blue .stat-value { color: #3b82f6; }
.theme-green .stat-value { color: #22c55e; }
.theme-orange .stat-value { color: #f97316; }
.theme-purple .stat-value { color: #8b5cf6; }
.theme-cyan .stat-value { color: #06b6d4; }

.stat-icon {
  width: 56px;
  height: 56px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
  flex-shrink: 0;
}

.stat-icon svg {
  width: 28px;
  height: 28px;
}

/* Icon Color Themes */
.icon-blue {
  background-color: #eff6ff;
  color: #3b82f6;
}
.stat-card:has(.icon-blue) { color: #3b82f6; }

.icon-green {
  background-color: #f0fdf4;
  color: #22c55e;
}
.stat-card:has(.icon-green) { color: #22c55e; }

.icon-orange {
  background-color: #fff7ed;
  color: #f97316;
}
.stat-card:has(.icon-orange) { color: #f97316; }

.icon-purple {
  background-color: #f5f3ff;
  color: #8b5cf6;
}
.stat-card:has(.icon-purple) { color: #8b5cf6; }

.icon-cyan {
  background-color: #ecfeff;
  color: #06b6d4;
}
.stat-card:has(.icon-cyan) { color: #06b6d4; }


/* Chart Section */
.chart-section {
  background: white;
  border-radius: 12px;
  padding: 1.5rem;
  box-shadow: 0 1px 3px rgba(0,0,0,0.1);
  border: 1px solid #e2e8f0;
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
  margin-bottom: 24px;
}

.section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
  padding-bottom: 1rem;
  border-bottom: 1px solid #f1f5f9;
  flex-shrink: 0;
}

.section-header h2 {
  font-size: 1.125rem;
  font-weight: 600;
  color: #0f172a;
  margin: 0;
}

.legend-indicator {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.875rem;
  color: #64748b;
}

.dot {
  width: 0.75rem;
  height: 0.75rem;
  background-color: #0ea5e9;
  border-radius: 50%;
}

.chart-container {
  flex: 1;
  width: 100%;
  min-height: 0;
  position: relative;
}
</style>
